require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-mayor-hogsett-recognizes-financial-center-first-cu-for-its-financial.json") })
        }
      }, "path---es-articles-mayor-hogsett-recognizes-financial-center-first-cu-for-its-financial");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-mayor-hogsett-recognizes-financial-center-first-cu-for-its-financial!./.cache/json/es-articles-mayor-hogsett-recognizes-financial-center-first-cu-for-its-financial.json
// module id = 2218
// module chunks = 231608221292675